/**
 * Check if a value is within snap range of a target
 * @param {number} value - The value to check
 * @param {number} target - The target value
 * @param {number} threshold - The snap threshold
 * @returns {boolean} True if within snap range
 */
export const isInSnapRange = (value, target, threshold) => {
  return Math.abs(value - target) <= threshold;
};
